import React, { useEffect } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";

function Header() {
  // Common style for store buttons to ensure equal width
  const storeButtonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    padding: "10px 16px",
    borderRadius: "8px",
    color: "white",
    textDecoration: "none",
    transition: "all 0.3s ease",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    width: "150px",
  };

  useEffect(() => {
    const login4 = document.querySelector(".btn-login4");
    const loginModal = document.querySelector(".login-modal-wrap");

    login4.addEventListener("click", () => {
      loginModal.classList.toggle("display-none");
    });
  }, []);


  return (
    <footer
      style={{
        background:
          "linear-gradient(160deg, #0f172a 0%, #1e293b 100%), linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255,255,255,0.3) 100%)",
        backgroundBlendMode: "normal",
        position: "relative",
        overflow: "hidden",
        bottom: 2,
      }}
    >
      <div className="container">
        <ul className="flex-row">
          <li>
            <a href="#hero">Home</a>
          </li>
          <li>
            <a href="#" className="btn-login4">
              Login
            </a>
          </li>
          {/* <li>
            <a href="#statistics">Statistiken</a>
          </li> */}
          <li>
            <a href="#support">Support</a>
          </li>
          <li>
            <a
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                window.location.href = "/Impressum";
              }}
            >
              Impressum
            </a>
          </li>
        </ul>
        <ul className="flex-row" style={{ gap: "20px", marginTop: "10px" }}>
          <li style={{ transition: "transform 0.3s ease" }}>
            <a
              href="https://play.google.com/store/apps/details?id=com.trainingsapp.trainingsapp"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                padding: "10px 16px",
                borderRadius: "8px",
                color: "white",
                textDecoration: "none",
                transition: "all 0.3s ease",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                width: "150px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "translateY(-2px)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <i style={{ color: "var(--color-theme)", fontSize: "1.5rem" }}>
                <FontAwesomeIcon
                  icon={icon({ name: "google-play", style: "brands" })}
                />
              </i>
              <span>Google Play</span>
            </a>
          </li>
          <li style={{ transition: "transform 0.3s ease" }}>
            <a
              href="https://apps.apple.com/at/app/elev8ion/id1645771356"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                padding: "10px 16px",
                borderRadius: "8px",
                color: "white",
                textDecoration: "none",
                transition: "all 0.3s ease",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                width: "150px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "translateY(-2px)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <i style={{ color: "var(--color-theme)", fontSize: "1.5rem" }}>
                <FontAwesomeIcon
                  icon={icon({ name: "app-store-ios", style: "brands" })}
                />
              </i>
              <span>App Store</span>
            </a>
          </li>
        </ul>
        <p>{"© 2025 ELEV8ION"}</p>

        <div
          className="bg-circle"
          style={{
            position: "absolute",
            width: "700px",
            height: "700px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(139, 92, 246, 0.2) 0%, rgba(139, 92, 246, 0) 70%)",
            // bottom: "-350px",
            // right: "-150px",
            animation: "float 10s ease-in-out infinite",
            zIndex: "0",
            pointerEvents: "none"
          }}
        ></div>
      </div>
    </footer>
  );
}

export default Header;
